export default __webpack_public_path__ + "76b0922e4243a527b7b176bb51f4bf38.png";